import Box from '@mui/material/Box'
import type { ReactNode } from 'react'

import { APP_SHELL_PAGE_TITLE_ROW_MARGIN_BOTTOM_PX } from '@/shared/layout/appShellPageLayout'

type Props = Readonly<{
  children: ReactNode
  actions?: ReactNode
  marginBottomPx?: number
}>

/** Title block left, optional filters/actions right — matches Sensemaker / SP list pages. */
export function StandardPageTitleRow({
  children,
  actions,
  marginBottomPx = APP_SHELL_PAGE_TITLE_ROW_MARGIN_BOTTOM_PX,
}: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 2,
        flexWrap: 'wrap',
        mb: `${marginBottomPx}px`,
      }}
    >
      {children}
      {actions}
    </Box>
  )
}
